import React from 'react';

import { Button, Box, makeStyles } from '@material-ui/core';
import PriorityHighIcon from '@material-ui/icons/PriorityHigh';

function CallToActionButton({ targetRef }) {
  const scrollToRef = () => window.scrollTo(0, targetRef.current.offsetTop - 100);
  const executeScroll = () => scrollToRef();
  const classes = makeStyles((theme) => ({
    button: {
      textTransform: 'capitalize',
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(4),
    },
  }))();

  return (
    <Box display="flex" justifyContent="center" displayPrint="none">
      <Button className={classes.button} size="large" variant="contained" color="primary" onClick={executeScroll} startIcon={<PriorityHighIcon />}>Want to take action?</Button>
    </Box>
  );
}

export default CallToActionButton;
